import { render } from "./ProductDonationInfo.vue?vue&type=template&id=cb047f5a&scoped=true&ts=true"
import script from "./ProductDonationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDonationInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ProductDonationInfo.vue?vue&type=style&index=0&id=cb047f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb047f5a"],['__file',"src/js/components/ProductDonationInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cb047f5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb047f5a', __exports__)) {
    api.reload('cb047f5a', __exports__)
  }
  
  module.hot.accept("./ProductDonationInfo.vue?vue&type=template&id=cb047f5a&scoped=true&ts=true", () => {
    api.rerender('cb047f5a', render)
  })

}


export default __exports__